import i from './contact-us.container';

export default i;
